
// src/web/components/main-page.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/main-page'
import {
  NavDrawer,
  Layout,
} from 'react-toolbox/lib/layout'
import {
  List,
  ListItem,
  ListSubHeader,
} from 'react-toolbox/lib/list'
import LeftSidebarUser from './left-sidebar-user.jsx'
import {
  Menu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import LeftSidebar from './left-sidebar.jsx'
import UserSelectionDialogProvider from './user-selection-dialog.jsx'
import GroupSelectionDialogProvider from './group-selection-dialog.jsx'
import EmojiPaletteProvider from './emoji-palette.jsx'
import StampPaletteProvider from './stamp-palette.jsx'
import ImagesViewProvider from './images-view.jsx'
import Loading from './loading.jsx'
import helpButtonTheme from './themes/help-button.css'
import drawerTheme from './themes/drawer.css'
import ConfirmDialog from './confirm-dialog.jsx'
import UserSettingsPage from './user-settings-page.jsx'
import WebNotification from 'react-web-notification'
import GoogleSiginProvider from './google-signin-provider.jsx'
import leftSidebarGroupListItemTheme from './themes/left-sidebar-group-list-item.css'
import _ from 'lodash'
import moment from 'moment'
import { track } from '../../helpers/analytics'
import config from '../../config'
import {
  Button,
} from 'react-toolbox/lib/button'

import * as Sentry from '@sentry/react'
import LiveChat from './live-chat.jsx'

class MainPage extends React.Component {
  state = { showTrialAlert : true }

  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.socketNotification && !_.isEqual(this.props.socketNotification, nextProps.socketNotification) && nextProps.socketNotification[0]) {
      var notification = _.find(nextProps.socketNotification, (socketNotification)=> {
        return !socketNotification.notification.delivered_at
      })
      notification = notification && notification.notification || undefined
      if (notification)
        this.setState({
          title: nextProps.t('label:新着のお知らせ'),
          body: notification.description,
          tag: `notification-${notification.notification_id}`,
          icon: notification.icon_image.thumb_url,
          onClick: ()=> nextProps.onWebNotification('notification', notification)
        })
    }

    if (nextProps.socketChat && !_.isEqual(this.props.socketChat, nextProps.socketChat) && nextProps.socketChat[0]) {
      var message = _.find(nextProps.socketChat, (socketChat)=> {
        return socketChat.appending && socketChat.chat.user.user_id != nextProps.user.user_id
      })
      message = message && message.chat || undefined
      if (message)
        this.setState({
          title: nextProps.t('label:新着のメッセージ', { name: message.user.name }),
          body: message.files.length > 0 && nextProps.t('label:添付ファイルが届いています') || message.message_text,
          tag: `chat-${message.message_id}`,
          icon: message.user.icon_image.thumb_url,
          onClick: ()=> nextProps.onWebNotification('chat', message)
        })
    }

    if (!this.props.user && nextProps.user) {
      if (nextProps.user.trial && nextProps.user.left_days < 0) {
        nextProps.logout()
      }

      this.configureSentry(nextProps.user)
      this.configureZendesk(nextProps.user)
    }
  }

  configureSentry = (user) => {
    Sentry.setUser({ id: user.user_id, username: `COMP-${user.account.account_id}-USER-${user.user_id}`})
  }

  configureZendesk = (user) => {
    // Zendesk APIの初期化が間に合っていない場合、zE.identifyがundefinedのままになっていることがありうる
    setTimeout(()=> zE && typeof zE.identify == 'function' && zE.identify({ name: user.name, email: user.email }), 60000)
  }

  openHelpPage = ()=> {
    window.open('https://support.getgamba.com/hc/ja')
    track('open_help')
  }
  activateZendesk = ()=> {
    // Check if the zE object and the activate method exist before calling it
    if (typeof zE === 'function' && typeof zE.activate === 'function') {
      zE.activate({ hideOnClose: true })
      track('open_inquiry')
    }
  }

  onClose = ()=> this.setState({
      title: undefined,
      body: undefined,
      tag: undefined,
      icon: undefined,
      onClick: undefined,
    })

  closeAlertMessage = ()=> this.setState({ showTrialAlert: false })  

  changePlan = () => {
    window.open(`${config.baseUrl}v3/contract`)
  }

  render() {
    const {
      t,
      user,
      children,
      groups,
      params,
      location,
      active,
      pinned,
      isFetching,
      onOverlayClick,
    } = this.props

    if (!user)
      return <div className="initial-loading"></div>

    const group_id = location.pathname == "/groups/home" ? 'home' : params.group_id

    return (
      <UserSelectionDialogProvider>
      <GroupSelectionDialogProvider>
      <StampPaletteProvider>
      <EmojiPaletteProvider>
      <GoogleSiginProvider>
      <ImagesViewProvider>
        <Layout ref={(c)=> this.drawer = c}>
          <NavDrawer active={active} theme={drawerTheme}
                pinned={pinned}
                onOverlayClick={onOverlayClick}>
            <LeftSidebarUser user={user} openUserSettingsPage={this.props.openUserSettingsPage} />
            <LeftSidebar ref={(c)=> this.sidebar = c} group_id={group_id} />
            <List selectable theme={leftSidebarGroupListItemTheme}>
              <ListSubHeader
                  caption={t('label:その他')} />
              <ListItem
                leftIcon='settings'
                theme={leftSidebarGroupListItemTheme}
                caption={t('label:個人設定')}
                onClick={this.props.openUserSettingsPage} />
              <ListItem
                leftIcon='open_in_new'
                theme={leftSidebarGroupListItemTheme}
                caption={t('label:ヘルプページを開く')}
                onClick={this.openHelpPage} />
              <ListItem
                leftIcon='help_outline'
                theme={leftSidebarGroupListItemTheme}
                caption={t('label:問い合わせる')}
                onClick={this.activateZendesk} />
            </List>
            {user && user.trial &&
            <div className={leftSidebarGroupListItemTheme.trialWrap}>
              <p style={{ marginTop: 10, marginBottom: 5 }}>{t('label:トライアルの有効期限')} :</p>
              <p style={{ marginBottom: 10 }}>{t('label:残りX日', { dates: user.left_days })}</p>
              {user.account_admin &&
              <Button primary onClick={this.changePlan} label={t('label:プラン変更')} />
              }
            </div>
            }
            <div className={helpButtonTheme.helpButtonArea}>
              <div className={helpButtonTheme.helpButtonGambaKun}/>
              <div className={helpButtonTheme.helpText}>{t('label:アプリ名')}</div>
            </div>
          </NavDrawer>
          <UserSettingsPage />
            {(groups || !isFetching) && children}
            <LiveChat />
        </Layout>
      </ImagesViewProvider>
      </GoogleSiginProvider>
      </EmojiPaletteProvider>
      </StampPaletteProvider>
      {user && user.account_admin && user.trial && user.left_days == 0 &&
      <ConfirmDialog open={this.state.showTrialAlert} trialDatesMessage centeredTitle 
        configBaseUrl={config.baseUrl}
        title={t('label:トライアル最終日です')}
        yesLabel={t('label:契約する')}
        noLabel={t('label:閉じる')}
        yesHref={`${config.baseUrl}v3/contract`}
        onNo={this.closeAlertMessage} />
      }
      <WebNotification
        ignore={!this.state.title}
        title={this.state.title || ''}
        timeout={10000}
        onClick={this.state.onClick}
        onClose={this.onClose}
        options={{
          body: this.state.body,
          icon: this.state.icon,
          tag: this.state.tag,
        }} />
      </GroupSelectionDialogProvider>
      </UserSelectionDialogProvider>
    )
  }
}

export const RawMainPage = MainPage
export default connect(MainPage)



// WEBPACK FOOTER //
// ./src/web/components/main-page.jsx